import { Injectable } from '@angular/core';
import { CrudApiProvider } from '../crud-api/crud-api';
import * as debug from 'debug';
import * as _ from 'lodash';
import { ToolsProvider } from '../tools/tools';
import { ModalController } from 'ionic-angular';

@Injectable()
export class BadgesProvider {
  log = debug('app:BadgesProvider');

  badges = [];
  _p;

  constructor(
    public crud: CrudApiProvider,
    public tools: ToolsProvider,
    public modalCtrl: ModalController
  ) {
    this.log('BadgesProvider Provider');
    this.loadBadges();
  }

  loadBadges(): Promise<any> {
    return (this._p =
      this._p ||
      this.crud.get('/api/badges').then(res => {
        this.badges = res.data;
        return this.badges;
      }));
  }

  getUserBadges(user) {
    return user.userBadges;
  }

  getBadges(filter, user?) {
    let badges = [];
    if (!_.get(filter, 'other')) {
      badges = _.filter(this.badges, filter);
    } else {
      delete filter['other'];
      let allBadges = _.cloneDeep(this.badges);
      _.each(filter, (v, k) => {
        _.remove(allBadges, [k, v]);
      });
      badges = allBadges;
    }

    if (user) {
      this.setBadgesActiveForUser(badges, user);
      badges = _.reverse(_.sortBy(badges, ['isActive']));
    }

    //removing isActive false and showIfInactive false badges
    _.remove(badges, badge => {
      if (!badge.isActive) return badge.showIfInactive === false;
    });

    return badges;
  }

  private groupBadgesByState(badges: Array<object>) {
    const grouped = _.groupBy(badges, 'state');
    this.log('grouped', grouped);
    return grouped;
  }

  getLocationBadgesForUser(user): Array<object> {
    const states = {
      FED: 'Federal Prison',
      AL: 'Alabama',
      AK: 'Alaska',
      AS: 'American Samoa',
      AZ: 'Arizona',
      AR: 'Arkansas',
      CA: 'California',
      CO: 'Colorado',
      CT: 'Connecticut',
      DE: 'Delaware',
      DC: 'District Of Columbia',
      FM: 'Federated States Of Micronesia',
      FL: 'Florida',
      GA: 'Georgia',
      GU: 'Guam',
      HI: 'Hawaii',
      ID: 'Idaho',
      IL: 'Illinois',
      IN: 'Indiana',
      IA: 'Iowa',
      KS: 'Kansas',
      KY: 'Kentucky',
      LA: 'Louisiana',
      ME: 'Maine',
      MH: 'Marshall Islands',
      MD: 'Maryland',
      MA: 'Massachusetts',
      MI: 'Michigan',
      MN: 'Minnesota',
      MS: 'Mississippi',
      MO: 'Missouri',
      MT: 'Montana',
      NE: 'Nebraska',
      NV: 'Nevada',
      NH: 'New Hampshire',
      NJ: 'New Jersey',
      NM: 'New Mexico',
      NY: 'New York',
      NC: 'North Carolina',
      ND: 'North Dakota',
      MP: 'Northern Mariana Islands',
      OH: 'Ohio',
      OK: 'Oklahoma',
      OR: 'Oregon',
      PW: 'Palau',
      PA: 'Pennsylvania',
      PR: 'Puerto Rico',
      RI: 'Rhode Island',
      SC: 'South Carolina',
      SD: 'South Dakota',
      TN: 'Tennessee',
      TX: 'Texas',
      UT: 'Utah',
      VT: 'Vermont',
      VI: 'Virgin Islands',
      VA: 'Virginia',
      WA: 'Washington',
      WV: 'West Virginia',
      WI: 'Wisconsin',
      WY: 'Wyoming',
    };
    let badges = this.getBadges({ location: true }, user);
    badges = this.groupBadgesByState(badges);
    badges = _.map(badges, (stateBadges, key) => {
      return {
        isOpen: false,
        stateCode: key,
        stateName: states[key],
        earnedBadges: _.size(_.filter(stateBadges, { isActive: true })),
        badges: _.reverse(_.sortBy(stateBadges, ['isActive'])),
      };
    });
    badges = _.sortBy(badges, 'stateName');
    if (badges.length > 0) {
      _.set(badges[0], 'isOpen', true);
    }
    return badges;
  }

  private setBadgesActiveForUser(badges, user) {
    const userBadges = this.getUserBadges(user);
    _.each(badges, badge => {
      if (_.includes(userBadges, badge.id)) {
        _.set(badge, 'isActive', true);
      } else {
        _.set(badge, 'isActive', false);
      }
    });
  }
  getBadgeById(badgeId) {
    return _.find(this.badges, { id: badgeId });
  }

  assignBadge(badge, user) {
    return this.crud.post(`/api/badges/${badge.id}/assign`, {
      users: [user._id],
    });
  }
  removeBadge(badge, user): Promise<any> {
    return this.crud.post(`/api/badges/${badge.id}/remove`, {
      users: [user._id],
    });
  }

  doesUserHaveBadge(badge, user): boolean {
    const userBadges = this.getUserBadges(user);
    return _.includes(userBadges, badge.id);
  }
}



// WEBPACK FOOTER //
// ./src/providers/badges/badges.ts